import React, {useEffect, useState} from 'react';
import {Doughnut} from 'react-chartjs-2';
import PropTypes from "prop-types";
import Spinner from "../Spinner";
import {isMobileHorizontalScreen, isMobileVerticalScreen} from "../../../utils/displayUtils";

DoughnutChart.propTypes = {
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    chartData: PropTypes.arrayOf(PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.number),
        borderColor:  PropTypes.arrayOf(PropTypes.string),
        backgroundColor:  PropTypes.arrayOf(PropTypes.string),
    })),
    dataType: PropTypes.string,
    measure: PropTypes.string,
    isLoading: PropTypes.bool
};

export default function DoughnutChart(props) {
    let {labels, chartData, dataType, measure='', isLoading, showSpinner, height} = props;

    const [prevChartData, setPrevChartData] = useState(null);

    useEffect(() => {
            setPrevChartData(chartData);
    }, [chartData, prevChartData]);

    const data = {
        datasets: [chartData],
        labels: labels,
        dataType: dataType
    };
    const chartOptions = {
        legend: {
            display: false,
        },
        tooltips: {
            backgroundColor: '#6c757d',
            titleFontFamily: '"Rubik", sans-serif',
            titleFontSize: 14,
            bodySpacing: 10,
            bodyFontFamily: '"Rubik", sans-serif',
            bodyFontSize: 12,
            displayColors: true,
            callbacks: {
                title: (items, data) => data.labels[items[0].index],
                label: (item, data) => " " + dataType + ": " + data.datasets[item.datasetIndex].data[item.index].toLocaleString("ru-RU") + " " + measure
                    + " " + (data.datasets[item.datasetIndex].data[item.index]/total*100).toFixed(2).toLocaleString("ru-RU") + "%",
            }
        },
        responsive: true,
        maintainAspectRatio: false
    };
    const total = chartData.data.reduce((sum, item) => sum + item, 0);
     height = isMobileHorizontalScreen()
        ? window.screen.height * 0.4
        :isMobileVerticalScreen()
            ? window.screen.height * 0.4
            : height
                ? height
                : 270;
    return (
        (isLoading && showSpinner) ? <Spinner/> :
      <Doughnut data={data} height={height} options={chartOptions}/>
    );
};